import React from "react";
import { Link } from "react-router-dom";
import { contact, socials } from "../../data/site";
import "./Footer.style.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="trait" />
      <div className="social-icons">
        {socials.map((social) => (
          <a
            key={social.name}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={social.name}
          >
            <i className={social.icon}></i>
          </a>
        ))}
      </div>
      <p className="footer-contact">
        <a href={contact.phoneHref}>{contact.phone}</a> ·{" "}
        <a href={`mailto:${contact.email}`}>{contact.email}</a> ·{" "}
        <Link to="/contact">Home studio à Millam</Link>
      </p>
      <p className="copyright">SIREN : {contact.siren}</p>
      <p className="copyright">
        Copyright © {new Date().getFullYear()} Pauline Limousin Photographies ·
        Tous droits réservés
      </p>
    </footer>
  );
};

export default Footer;
